import { render, staticRenderFns } from "./AddAuctionImage.vue?vue&type=template&id=3437d4ec&scoped=true&"
import script from "./AddAuctionImage.vue?vue&type=script&lang=js&"
export * from "./AddAuctionImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3437d4ec",
  null
  
)

export default component.exports